import React from 'react'
import Section from '../ui/section'
import LayoutContainer from '../components/container'
import twitterSvg from './assets/twitter.svg';
import linkedinSvg from './assets/linkedin.svg';
import appstoreBadge from './assets/app-store-badge.png';
import googleplayBadge from './assets/google-play-badge.png';

import styles from './footer.module.css';

const MAILCHIMP_URL = 'https://wagetap.us17.list-manage.com/subscribe/post?u=5fa7b333b9428d824e8a1f64c&amp;id=fc9f730b2a';

export default () => (
  <Section variant="black" classNames={styles.footer}>
    <LayoutContainer>
      <div className={styles.navContainer}>
        <div className={styles.subscribeFormContainer}>
          <p className={styles.subscribeFormTitle}>Subscribe to our newsletter</p>
          <form action={MAILCHIMP_URL} method="post" name="mc-embedded-subscribe-form">
            <input
                type="email"
                name="EMAIL"
                placeholder="Enter your email"
                required/>
            <button name="subscribe" className={styles.subscribeButton} type="submit">
              Subscribe
            </button>
          </form>
        </div>

        <nav className={styles.socialLinks}>
          <ul>
            <li>
              <a href="https://www.linkedin.com/company/wagetap/" rel="noreferrer" target="_blank">
                <img alt="Wagetap on LinkedIn" src={linkedinSvg}/>
              </a>
            </li>
            <li>
              <a href="https://twitter.com/wagetap" rel="noreferrer" target="_blank">
                <img alt="Wagetap on Twitter" src={twitterSvg}/>
              </a>
            </li>
          </ul>
        </nav>
        <nav className={styles.appLinks}>
          <ul>
            <li>
              <a
                target="_blank"
                rel="noreferrer"
                href="https://apps.apple.com/au/app/wagetap/id1513517219">
                <img
                    src={appstoreBadge}
                    alt="Wagetap on App Store"/>
              </a>
            </li>
            <li>
              <a
                target="_blank"
                rel="noreferrer"
                href="https://play.google.com/store/apps/details?id=com.wagetap">
                <img
                    src={googleplayBadge}
                    alt="Wagetap on App Store"/>
              </a>
            </li>
          </ul>
        </nav>
      </div>
      <p className={styles.copyrights}>&copy; Wagetap™ {(new Date()).getFullYear()}  &middot;  All Rights Reserved</p>
    </LayoutContainer>
  </Section>
)
